import { NavIconProps } from './index';
import * as React from 'react';

interface MarketplaceProps extends NavIconProps {
  variant?: 'currentColor' | 'default';
}

export const Marketplace: React.FunctionComponent<MarketplaceProps> = ({
  size = 24,
  variant,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
      {...props}
    >
      <path d="m21,19.5V4.5l-9,9L3,4.5h0v15h18Zm-12.21-3.88c-.18.18-.42.31-.67.36-.25.05-.52.02-.76-.07-.24-.1-.44-.27-.59-.48-.14-.22-.22-.47-.22-.73s.08-.51.22-.73c.14-.22.35-.38.59-.48.24-.1.5-.13.76-.07s.49.18.67.36c.25.25.38.58.38.93s-.14.68-.38.93Z" />
    </svg>
  );
};

export default Marketplace;
